import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import HowItWorksSection from './components/HowItWorksSection';
import ComparisonSection from './components/ComparisonSection';
import CategoriesSection from './components/CategoriesSection';
import SecuritySection from './components/SecuritySection';
import FAQSection from './components/FAQSection';
import ArticleCTASection from './components/ArticleCTASection';
import FinalCTASection from './components/FinalCTASection';
import ArticlesGridSection from './components/ArticlesGridSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.fun';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spreadsheet Guide',
  alternateName: 'Itaobuy Spreadsheet - La Guida Italiana',
  url: SITE_URL,
  description: 'La guida italiana più completa su Itaobuy Spreadsheet. Recensioni, tutorial, sicurezza e confronti dettagliati.',
  inLanguage: 'it',
  publisher: {
    '@type': 'Organization',
    name: 'itaobuyspread.fun',
    url: SITE_URL,
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'itaobuyspread.fun',
  url: SITE_URL,
  description: 'Guida informativa indipendente su Itaobuy Spreadsheet per il mercato italiano.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AboutSection />
        <HowItWorksSection />
        <ComparisonSection />
        <CategoriesSection />
        <ArticlesGridSection />
        <SecuritySection />
        <ArticleCTASection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
}